import React, { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useParams } from "react-router-dom";
import {
  Bill,
  GetPreviewUpfrontPaymentPlan,
  UpfrontPaymentPlan,
} from "./Services/UpfrontPaymentService";
import { StepperIndex } from "./types";
import {
  UpfrontPaymentStripeContent,
  UpfrontPaymentStripeContentProps,
} from "./UpfrontPaymentStripeContent";

const stripeUpfrontPromise = import.meta.env.VITE_UPFRONT_STRIPE_PK
  ? loadStripe(import.meta.env.VITE_UPFRONT_STRIPE_PK)
  : null;

// Main component that wraps everything with Elements
export const UpfrontPaymentStripe: React.FC<
  UpfrontPaymentStripeContentProps
> = (props) => {
  const { currentStep, upfrontPayment } = props;
  const [paymentPlanPreviewSteps, setPaymentPlanPreviewSteps] =
    useState<UpfrontPaymentPlan[]>();

  const { billingPK, adminID } = useParams<{
    billingPK: string;
    adminID?: string;
  }>();

  useEffect(() => {
    const getUpfrontPaymentPlanDetails = async () => {
      if (upfrontPayment?.portal_bill_status === "outstanding") {
        const paymentPlanResponse = await GetPreviewUpfrontPaymentPlan(
          billingPK,
          adminID,
        );
        const paymentPlanJson = await paymentPlanResponse.json();
        setPaymentPlanPreviewSteps(paymentPlanJson);
      }
    };

    getUpfrontPaymentPlanDetails();
  }, [upfrontPayment, billingPK, adminID]);

  const getCharge = () => {
    if (
      StepperIndex.PaymentPlan === currentStep &&
      paymentPlanPreviewSteps?.length
    ) {
      return paymentPlanPreviewSteps[0].amount;
    }
    return upfrontPayment?.balance || 10000;
  };

  const options = React.useMemo(
    () => ({
      mode: "payment" as "payment" | "setup" | "subscription" | undefined,
      paymentMethodCreation: "manual" as "manual" | undefined,
      currency: "usd",
      amount: getCharge(),
    }),
    [upfrontPayment, paymentPlanPreviewSteps, currentStep],
  );

  return (
    <Elements stripe={stripeUpfrontPromise} options={options}>
      <UpfrontPaymentStripeContent {...props} />
    </Elements>
  );
};
